var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdminAltB = function SvgAdminAltB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 682.67 682.67",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "admin_alt_b_svg2__a",
    x1: 101.47,
    x2: 565.47,
    y1: 584.62,
    y2: 36.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#admin_alt_b_svg2__a",
    id: "admin_alt_b_svg2__b",
    x1: 121.19,
    x2: 585.19,
    y1: 601.33,
    y2: 53.33
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#admin_alt_b_svg2__a",
    id: "admin_alt_b_svg2__c",
    x1: 121.27,
    x2: 585.27,
    y1: 601.39,
    y2: 53.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#admin_alt_b_svg2__a",
    id: "admin_alt_b_svg2__d",
    x1: 31.75,
    x2: 495.75,
    y1: 525.59,
    y2: -22.41
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M268.17 301.33c0 40.34 32.82 73.17 73.17 73.17s73.17-32.82 73.17-73.17-32.82-73.17-73.17-73.17-73.17 32.82-73.17 73.17m73.16-60.16c33.18 0 60.17 26.99 60.17 60.17s-26.99 60.17-60.17 60.17-60.17-26.99-60.17-60.17 26.99-60.17 60.17-60.17",
    style: {
      fill: "url(#admin_alt_b_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m670.61 294.96-62.51-12.49c-6.84-31.01-19.1-60.6-36.5-88.09L609.27 139a6.49 6.49 0 0 0-.78-8.25l-56.57-56.57a6.5 6.5 0 0 0-8.25-.78c-16.53 11.24-45.51 30.96-55.52 37.76-27.24-17.43-56.79-29.72-87.94-36.59l-12.5-62.51a6.51 6.51 0 0 0-6.37-5.23h-80a6.49 6.49 0 0 0-6.37 5.23l-12.49 62.51c-31.16 6.87-60.71 19.17-87.94 36.6-10.03-6.82-38.96-26.5-55.53-37.77a6.49 6.49 0 0 0-8.25.78l-56.57 56.57a6.5 6.5 0 0 0-.78 8.25l37.67 55.38c-17.4 27.48-29.66 57.07-36.5 88.09l-62.51 12.49a6.51 6.51 0 0 0-5.23 6.37v80c0 3.1 2.19 5.77 5.23 6.37l62.51 12.49c6.87 31.17 19.17 60.71 36.6 87.94-6.82 10.03-26.5 38.96-37.77 55.53a6.49 6.49 0 0 0 .78 8.25l56.57 56.57a6.5 6.5 0 0 0 8.25.78l55.38-37.67c27.49 17.41 57.08 29.67 88.09 36.5l12.49 62.51a6.51 6.51 0 0 0 6.37 5.23h80c3.1 0 5.77-2.19 6.37-5.23l12.5-62.51c31.16-6.87 60.7-19.16 87.94-36.6 10.03 6.82 38.96 26.5 55.53 37.77 2.58 1.75 6.05 1.43 8.25-.78l56.57-56.57a6.5 6.5 0 0 0 .78-8.25c-11.27-16.56-30.95-45.5-37.77-55.53 17.43-27.24 29.73-56.78 36.6-87.94l62.51-12.49a6.51 6.51 0 0 0 5.23-6.37v-80c0-3.1-2.19-5.77-5.23-6.37ZM662.83 376l-61.48 12.29a6.49 6.49 0 0 0-5.09 5.08c-6.62 32.48-19.4 63.18-37.98 91.25a6.52 6.52 0 0 0-.12 7c.1.17.18.29 37.33 54.91l-48.96 48.96c-54.62-37.16-54.75-37.24-54.92-37.34a6.5 6.5 0 0 0-6.98.12c-28.07 18.59-58.77 31.37-91.25 37.98a6.52 6.52 0 0 0-5.08 5.09l-12.29 61.48h-69.34l-12.29-61.48a6.49 6.49 0 0 0-5.08-5.09c-32.32-6.58-63.09-19.33-91.46-37.9a6.5 6.5 0 0 0-7.22.07l-54.48 37.07-48.96-48.96c37.15-54.62 37.23-54.74 37.33-54.91a6.5 6.5 0 0 0-.12-7c-18.58-28.06-31.36-58.76-37.98-91.26a6.52 6.52 0 0 0-5.1-5.08l-61.48-12.29v-69.34l61.48-12.29a6.51 6.51 0 0 0 5.1-5.08c6.59-32.32 19.34-63.1 37.9-91.46a6.52 6.52 0 0 0-.06-7.22l-37.07-54.48 48.96-48.97c54.62 37.16 54.74 37.23 54.91 37.34a6.5 6.5 0 0 0 6.99-.12c28.06-18.58 58.77-31.36 91.26-37.98a6.52 6.52 0 0 0 5.08-5.1l12.29-61.48h69.34l12.29 61.48a6.5 6.5 0 0 0 5.08 5.1c32.47 6.61 63.18 19.39 91.26 37.97 2 1.32 4.55 1.44 6.66.31q.41-.22 55.24-37.51l48.96 48.97-37.07 54.48a6.52 6.52 0 0 0-.07 7.22c18.56 28.36 31.31 59.14 37.9 91.46a6.52 6.52 0 0 0 5.09 5.08l61.48 12.29z",
    style: {
      fill: "url(#admin_alt_b_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.84 156c-3.46-.94-7.04 1.1-7.98 4.56-.95 3.46 1.1 7.04 4.56 7.98C456.56 186.03 521.5 251 521.5 341.34c0 57.22-26.82 108.3-68.54 141.32-8.95-53.83-55.91-94.49-111.62-94.49S238.7 428.8 229.73 482.6c-6.59-5.2-12.86-10.86-18.71-16.98-34.28-35.88-51.92-83.01-49.66-132.69 3.81-77.22 55.64-143.29 128.97-164.42 3.45-.99 5.44-4.6 4.45-8.05s-4.59-5.44-8.05-4.45c-36.67 10.57-70.46 33.09-95.16 63.44-26.21 32.2-41.15 71.22-43.2 112.86-2.42 53.29 16.49 103.82 53.24 142.28 17.9 18.73 38.97 33.47 62.62 43.81 24.42 10.68 50.36 16.09 77.1 16.09 51.4 0 99.8-19.94 136.26-56.14 36.7-36.43 56.91-85.1 56.91-137.03 0-43.36-14.41-84.64-41.68-119.37-25.46-32.43-59.9-55.86-96.98-65.97ZM241.68 491.26c5.08-50.81 48.14-90.09 99.66-90.09s94.63 39.32 99.66 90.18c-28.56 19.04-62.84 30.15-99.67 30.15s-70.28-10.75-99.65-30.24",
    style: {
      fill: "url(#admin_alt_b_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 158,
    r: 12.5,
    style: {
      fill: "url(#admin_alt_b_svg2__d)"
    }
  }));
};
export default SvgAdminAltB;